import { defineMessages } from 'react-intl';

export default defineMessages({
    loanNumber: {
        id: 'ml.common.component.PolicySummaryAdditionalInterests.Loan #',
        defaultMessage: 'Loan #: '
    }
});
